import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Root = styled(Box)`
  @keyframes slideInUp {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes slideOutDown {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(50px);
      opacity: 0;
    }
  }
  .tic-dcc.widget {
    animation: slideInUp 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    &-entering {
      animation-name: slideInUp;
    }
    &-entered {
      display: inherit;
      visibility: visible;
    }
    &-exiting {
      animation: slideOutDown 0.5s cubic-bezier(0.77, 0, 0.175, 1) both;
    }
    &-exited {
      display: none;
      visibility: hidden;
    }
  }
`;

const scaleInAnimation = keyframes`
 0% { opacity: 0; transform: scale(0); }
 100% { opacity:1; transform: scale(1);}
`;

const slideInAnimation = keyframes`
  0% { width: 0; opacity: 0; }
  100% { width: 350px; opacity: 1;  }
`;

const slideOutAnimation = keyframes`
  0% { opacity: 1; width: 250px; }
  100% { opacity: 0; width: 0; }
`;

export const Banner = styled(Box)(
  ({ theme }) => `
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1300;
  height: 110px;
  overflow: hidden;
  z-index: 2147483010;
  ${theme.breakpoints.up('sm')} {
    height: 60px;
  }
`,
);

export const TimedPopup = styled(Box)`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2147483030;
  display: ${({ open }) => (open ? 'block' : 'none')};
`;

export const WidgetContainer = styled(Box)`
  position: fixed;
  width: 0;
  height: 0;
  bottom: 0;
  right: 0;
  z-index: 2147483029;
`;

export const LauncherButtonWrapper = styled(Box)`
  animation: ${scaleInAnimation} 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  border-radius: 50%;
  border: medium none;
  height: 60px;
  overflow: hidden;
  position: fixed;
  width: 60px;
  box-shadow: rgba(0, 0, 0, 0.2) 5px 15px 30px;
  bottom: 20px;
  right: 20px;
  z-index: 2147483029;
  &.left {
    right: unset;
    left: 20px;
  }
`;

export const LauncherTextWrapper = styled(Box)`
  border-radius: 40px;
  box-shadow: rgba(0, 0, 0, 0.2) 5px 15px 30px;
  box-sizing: border-box;
  height: 70px;
  overflow: hidden;
  position: fixed;
  width: 350px;
  max-width: calc(100% - 25px);
  z-index: 2147483029;
  opacity: 1;
  bottom: 15px;
  right: 15px;
  animation: ${slideInAnimation} 0.5s ease-in both;
  &.closed {
    animation: ${slideOutAnimation} 0.5s ease-out both;
  }
  &.left {
    right: unset;
    left: 15px;
  }
`;

export const LauncherStickyButtonWrapper = styled(Box)`
  border-radius: 40px;
  box-shadow: rgba(0, 0, 0, 0.2) 5px 15px 30px;
  box-sizing: border-box;
  height: 70px;
  overflow: hidden;
  position: fixed;
  width: 350px;
  max-width: calc(100% - 25px);
  z-index: 2147483029;
  opacity: 1;
  bottom: 15px;
  right: 15px;
  transition: all 0.3s ease-in-out;
  animation: ${slideInAnimation} 0.3s ease-in both;
  &.closed {
    animation: ${slideOutAnimation} 0.3s ease-out both;
  }
  &.left {
    right: unset;
    left: 15px;
  }
`;

export const WidgetWrapper = styled(Box)(
  ({ theme }) => `
  position: fixed;
  width: 360px;
  height: calc(100% - 80px);
  max-height: 700px;
  min-height: 250px;
  opacity: 1;
  overflow: hidden;
  border-radius: 28px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 5px 40px 0;
  z-index: 2147483028;
  bottom: 40px;
  right: 40px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
  }
  &.fullscreen {
    z-index: 2147483040;
    width: 100%;
    height: 100%;
    max-width: 100%;
    min-width: 100%;
    border-radius: 0;
    bottom: 0;
    right: 0;
    top: 0;
  }
   &.left {
    right: unset;
    left: 15px;
  }
  ${theme.breakpoints.down('sm')} {
    z-index: 2147483040;
    width: 100%;
    height: 100%;
    max-width: 100%;
    min-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    bottom: 0;
    right: 0;
  }
`,
);
